<template>
  <div class="footer-wrapper">
    <div class="footer-content">
      <div class="footer-left">
        <span>&copy; {{ currentYear }} Gescom Project. Todos los derechos reservados.</span>
      </div>
      <div class="footer-right">
        <span>Versión {{ appVersion }}</span>
        <span class="mx-2">|</span>
        <a href="#" class="text-muted">Ayuda</a>
        <span class="mx-2">|</span>
        <a href="#" class="text-muted">Soporte</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      appVersion: '1.0.0',
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
  },
}
</script>

<style lang="scss" scoped>
.footer-wrapper {
  padding: 1rem 2rem;
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.footer-left {
  font-size: 0.875rem;
  color: #6c757d;
}

.footer-right {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  color: #6c757d;
}

.footer-right a {
  text-decoration: none;
  color: #6c757d;
  transition: color 0.2s ease;
}

.footer-right a:hover {
  color: #495057;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    text-align: center;
  }
  
  .footer-right {
    justify-content: center;
  }
}
</style>
